<mc-license-user-avatar *ngIf="currentLicenseUser$ | async as currentLicenseUser" [licenseUser]="currentLicenseUser" [size]="'small'" class="navbar-item"></mc-license-user-avatar>
<button mat-icon-button class="flip-button">
    <mat-icon matListIcon [fontSet]="'project-titan'" [fontIcon]="'icon-expand'"></mat-icon>
</button>
